<div class="container-fluid loader-container">
    <header class="d-flex space-between page-header">
        <h2>
            Mailtemplates
        </h2>
        <div class="actions">
            <button (click)="openModal({})" class="btn btn-primary">
                Toevoegen
            </button>
        </div>
    </header>

    <app-table-guru [apiEndpoint]="'/office/mail-templates'" [columnMapping]="[
    { key: 'subject', label: 'Onderwerp' },
    { key: 'sender_name', label: 'Verzender naam' },
    { key: 'type', label: 'Type' }
  ]" [itemsPerPage]="10" [openModalComponent]="editFormReference" [reload]="reloadItems">
    </app-table-guru>
</div>